import 'echarts-wordcloud';
import 'echarts-liquidfill'
import { growthPortfolioData } from '@/assets/data.js';
// 自我关注雷达图
export function radarEcharts (echarts) {
  // const { ratio, dimension, dataList } = echartsdata;
  let myChartWarnBar = echarts.init(document.getElementById("focusradarEchart"));
  let optionWarnBar = {
    grid: {
      top: '30px',
      containLabel: true,
    },
    // radar: {
    //   splitArea: {
    //     show: false
    //   }
    // },
    tooltip: {
      trigger: "axis",
      // formatter: (params) => {
      //   return (
      //     params[0].name +
      //     "<br />" +
      //     params[0].data.text +
      //     "：" +
      //     params[0].value +
      //     "人" +
      //     "<br />" +
      //     "人数占比：" +
      //     params[1].value +
      //     "%"
      //   );
      // },
    },
    legend: {
      orient: 'vertical',              //这里主要是标识不同颜色代表不同的同学
      x: 'right',
      y: 'bottom',
      data: ['A同学']
    },
    polar: [
      {
        indicator: growthPortfolioData.learnStudy.indicator,
        name: {
          textStyle: {
            color: '#595959'
          }
        }
      }
    ],
    calculable: true,
    series: [
      {
        type: 'radar',
        data: growthPortfolioData.learnStudy.studyData,
        areaStyle: {
          color: '#CDE3FF'
        },
        lineStyle: {
          color: '#368FFF'
        },
        symbol: 'emptyCircle',
        // symbolSize: '0.02604rem',
        color: '#368FFF',
        label: {
          normal: {
            fontSize: "0.07292rem",
            // color: '#595959',
            borderWidth: '0.02604rem',
          },
          color: '#595959',
          // data: ratio,
        },
      }
    ],
  };
  myChartWarnBar.setOption(optionWarnBar);
}
// 心理状态折线图
export function psychologicalLineEcharts (echarts, id) {
  let myChartWarnBar = echarts.init(document.getElementById(id));
  let optionWarnBar = {
    grid: {
      show: false,
      top: "50",
      left: "20",
      right: "34",
      bottom: "0",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      // formatter: (params) => {
      //   return (
      //     params[0].name +
      //     "<br />" +
      //     params[0].data.text +
      //     "：" +
      //     params[0].value +
      //     "人" +
      //     "<br />" +
      //     "人数占比：" +
      //     params[1].value +
      //     "%"
      //   );
      // },
    },
    xAxis: [
      {
        type: "category",
        data: growthPortfolioData.psychologicalStatus.dataX,
        axisLabel: {
          color: "#81868C",
          // margin: 30, // 刻度标签与轴线之间的距离
          interval: 4, // 坐标轴刻度标签的显示间隔
          // rotate: 20, // 刻度标签旋转的角度
          align: "left", // 文字水平对齐方式
          itemStyle: {
            fontSize: "0.0625rem"
          }
        },
        splitLine: {
          // show: false
          lineStyle: {
            color: "#F0F1F4",
          },
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#F0F1F4",
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        minInterval: 1,
        min: 30,
        splitLine: {
          show: false,
          // lineStyle: {
          //   color: "#00D8EF",
          //   type: 'dashed'
          // }
        },
        label: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#F0F1F4",
          },
        },
        axisLabel: {
          show: false
        }
      },
    ],
    legend: {
      data: ['情绪状态', '学业状态'], //图例的数据数组
      show: true,
      icon: "rect",
      top: '14',
      left: '20',
      bottom: '20',
      itemWidth: 8,
      itemHeight: 8,
      selectedMode: false,
      textStyle: {
        color: "#595959",
        fontSize: 12,
      },
    },
    series: [
      {
        type: "line",
        color: "#59A4FF",
        data: growthPortfolioData.psychologicalStatus.dataY1,
        smooth: true,
        name: '情绪状态',
        symbol: "none"
      },
      {
        type: "line",
        color: "#FFBD2A",
        data: growthPortfolioData.psychologicalStatus.dataY2,
        smooth: true,
        name: '学业状态',
        symbol: "none"
      },
      {
        type: "line",
        color: "red",
        data: growthPortfolioData.psychologicalStatus.dataf,
        symbol: "none",
        name: '预警值',
        itemStyle: {
          normal: {
            lineStyle: {
              width: 2,
              type: 'dotted', //'dotted'虚线 'solid'实线
              dashOffset: 5
            }
          }
        },
      },
    ],
  };
  myChartWarnBar.setOption(optionWarnBar);
}
// 压力源与压力程度柱形图
export function pressBarEcharts (echarts, id) {
  let myChartWarnBar = echarts.init(document.getElementById(id));
  let labelStyle = {
    normal: {
      show: true,
      position: 'inside',
      formatter: function (param) {
        var res = '';
        res += param.data.text;
        return res;
      },
      textStyle: {
        color: '#fff',
        fontSize: '12'
      }
    }
  };

  let itemStyle = {
    normal: {
      borderColor: '#fff',
      borderWidth: 2,
      barBorderRadius: [0, 0, 0, 0]
    }
  };
  let pressBar = {
    color: ['#FE907D', '#FFBD2A', '#59A4FF'],
    title: {
      text: '*说明：按六大维度压力高低排序，条形图越长，代表压力程度越高',
      textStyle: {
        color: '#595959',
        fontSize: 12,
        fontWeight: 400,
      },
      bottom: 16,
      left: 76
    },
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (params) => {
        return params.data.text;
      }
    },
    legend: {
      top: 0,
      left: 80,
      data: ["轻度", "中度", '重度'],
      selectedMode: false,
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: 14,
        color: "#81868C"
      },
    },
    grid: {
      left: '3%',
      right: '64',
      bottom: '49',
      top: '28',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      axisTick: {
        show: false
      },
      axisLabel: {
        show: false
      },
      splitLine: {
        show: false
      },
    },
    yAxis: {
      type: 'category',
      data: [
        '自我认识',
        '社会与适应',
        '人际关系',
        '升学择业',
        '情绪发展',
        '学会学习'
      ],
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#E6E9ED'
        }
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
          color: 'rgba(65, 65, 65, 1)'
        }
      },
      formatter: function (params) {
        // 修改纵轴显示文本
        return params;
      }
    },
    series: [
      {
        name: '重度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        itemStyle: itemStyle,
        label: labelStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          {},
          {},
          {},
          {
            value: '200',
            name: '重度',
            text: '学业生涯'
          },
          {
            value: '200',
            name: '重度',
            text: '情绪控制'
          },
          {
            value: '200',
            name: '重度',
            text: '学业情绪'
          }
        ]
      },
      {
        name: '重度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        label: labelStyle,
        itemStyle: itemStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          {},
          {},
          {},
          {},
          {},
          {
            value: '200',
            name: '重度',
            text: '学习适应'
          }
        ]
      },
      {
        name: '中度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        itemStyle: itemStyle,
        label: labelStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          {},
          {
            value: '200',
            name: '中度',
            text: '学业适应'
          },
          {
            value: '200',
            name: '中度',
            text: '亲子关系'
          },
          {
            value: '200',
            name: '中度',
            text: '职业生涯'
          },
          {
            value: '200',
            name: '中度',
            text: '情绪觉察'
          },
          {}
        ]
      },
      {
        name: '轻度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        label: labelStyle,
        itemStyle: itemStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          {
            value: '200',
            name: '轻度',
            text: '自我认识'
          },
          {
            value: '200',
            name: '轻度',
            text: '价值观'
          },
          {
            value: '200',
            name: '轻度',
            text: '同伴交往'
          },
          {
            value: '200',
            name: '轻度',
            text: '学职规划'
          },
          {
            value: '200',
            name: '轻度',
            text: '情绪管理'
          },
          {
            value: '200',
            name: '轻度',
            text: '学习动力'
          }
        ]
      },
      {
        name: '轻度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        label: labelStyle,
        itemStyle: itemStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          {
            value: '200',
            name: '轻度',
            text: '自我效能感'
          },
          { value: '200', name: '轻度', text: '生活适应' },
          { value: '200', name: '轻度', text: '沟通技巧' },
          {},
          {},
          { value: '200', name: '轻度', text: '学习能力' }
        ]
      },
      {
        name: '轻度',
        type: 'bar',
        barWidth: 26,
        stack: 'total',
        label: labelStyle,
        itemStyle: itemStyle,
        emphasis: {
          focus: 'series'
        },
        data: [
          { value: '200', name: '轻度', text: '自我管理' },
          '',
          '',
          {},
          {},
          { value: '200', name: '轻度', text: '学习策略' }
        ]
      }
    ]
  };

  myChartWarnBar.setOption(pressBar);
}
